module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.editingSheet) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), (_vm.editingSheet) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.classSheetView
  }, [(_vm.seendingSheet) ? _c('loading') : _vm._e(), _c('div', {
    ref: "sheet",
    staticClass: "col-md-12",
    style: (_vm.setHeight),
    on: {
      "scroll": function($event) {
        _vm.scrolling($event)
      }
    }
  }, [_c('div', {
    staticClass: "well"
  }, [_c('modal', {
    attrs: {
      "name": "keys-info",
      "height": 700,
      "width": 880,
      "scrollable": true,
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "col-md-12 center-element"
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "static/images/helperKeys.png"
    }
  })]), _c('div', {
    staticClass: "col-md-12 center-element",
    staticStyle: {
      "padding": "0px",
      "bottom": "0px",
      "position": "absolute"
    }
  }, [_c('button', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Fechar")])])]), (_vm.queueSheets.total > 1) ? _c('div', {
    staticClass: "row mb20"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPdfCookie),
      expression: "showPdfCookie"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPdfCookie) ? _vm._i(_vm.showPdfCookie, null) > -1 : (_vm.showPdfCookie)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showPdfCookie,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPdfCookie = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPdfCookie = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPdfCookie = $$c
        }
      }
    }
  }), _vm._v("  Mostrar PDF")])]), _c('div', {
    staticClass: "col-md-1 pull-right center-element"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.openModalInfoKeys()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-question-sign"
  })])]), _c('div', {
    staticClass: "col-md-2 pull-right center-element"
  }, [_c('h4', [_vm._v(_vm._s(_vm.queueSheets.actual + 1) + " de " + _vm._s(_vm.queueSheets.total))])]), _c('div', {
    staticClass: "col-md-6 pull-right center-element"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sheetInfo.employee) + " - " + _vm._s(_vm._f("isoDate")(_vm.sheetInfo.start_date)))])])]) : _vm._e(), (_vm.queueSheets.total <= 1) ? _c('div', {
    staticClass: "row mb20"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPdfCookie),
      expression: "showPdfCookie"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPdfCookie) ? _vm._i(_vm.showPdfCookie, null) > -1 : (_vm.showPdfCookie)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showPdfCookie,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPdfCookie = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPdfCookie = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPdfCookie = $$c
        }
      }
    }
  }), _vm._v("  Mostrar PDF")])]), _c('div', {
    staticClass: "col-md-8 center-element"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sheetInfo.employee) + " - " + _vm._s(_vm._f("isoDate")(_vm.sheetInfo.start_date)))])]), _c('div', {
    staticClass: "col-md-1 center-element"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.openModalInfoKeys()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-question-sign"
  })])])]) : _vm._e(), _c('hr'), _c('sheet'), _c('hr'), (_vm.canEditCurrentSheet) ? _c('div', {
    staticClass: "row mb40",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-2"
  }, [_c('button', {
    staticClass: "bnt btn3d btn-info btn-sm",
    on: {
      "click": _vm.tempNextSheet
    }
  }, [_vm._v("Próxima folha")])]), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-sm-offset-1"
  }, [_c('button', {
    staticClass: "bnt btn3d btn-warning btn-sm pull-right",
    attrs: {
      "disabled": _vm.hasAnyPendingSeending || _vm.seendingSheet
    },
    on: {
      "click": function($event) {
        _vm.reprocessSheet()
      }
    }
  }, [_vm._v("Reprocessar"), _c('br'), _vm._v("Folha")])]), _c('div', {
    staticClass: "col-md-2 col-sm-2"
  }, [_c('button', {
    staticClass: "bnt btn3d btn-danger btn-sm",
    attrs: {
      "disabled": _vm.hasAnyPendingSeending || _vm.seendingSheet
    },
    on: {
      "click": function($event) {
        _vm.ignoreSheet()
      }
    }
  }, [_vm._v("Ignorar"), _c('br'), _vm._v("Folha")])]), _c('div', {
    staticClass: "col-md-6 col-sm-5 center-element"
  }, [_c('button', {
    staticClass: "bnt btn3d btn-success btn-lg",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "disabled": _vm.hasAnyPendingSeending || _vm.seendingSheet
    },
    on: {
      "click": function($event) {
        _vm.sendSheet()
      }
    }
  }, [_vm._v("Aprovar")])])]) : _vm._e()], 1)])], 1), (_vm.showPdf) ? _c('div', {
    ref: "imagepdf",
    staticClass: "col-md-5 pdf",
    style: (_vm.setHeight)
  }, [_c('img', {
    style: (_vm.imageBlockStyle),
    attrs: {
      "src": _vm.sheetInfo.imageUrl
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-3 center-element"
  }, [_c('h1', [_vm._v("Carregando")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5db1c80"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checker.vue
// module id = 432
// module chunks = 2